module.exports = __webpack_public_path__ + "static/media/fasaddoor3.b21db7f2.jpeg";